import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { Guard } from '../../components/layout/Guard';

const IntegrationsPage = lazy(() => import('./IntegrationsPage'));

const routes: RouteObject[] = [{ path: '/integrations', element: <Guard any={['integration.read']}><IntegrationsPage /></Guard> }];
export default routes;
